<template>
	<basic-container>
		<template v-if="insureType == 3">
			<product-3-details @insure="handleInsure"></product-3-details>
		</template>
		<template v-else-if="insureType == 6">
			<product-6-common v-if="isFgkCommon(productId)" :productId="productId" @insure="handleInsure"></product-6-common>
			<product-6-common-year
				v-if="isFgkCommonYear(productId)"
				:productId="productId"
				@insure="handleInsure"></product-6-common-year>
			<product-45-91-details
				v-else-if="isFgkZungui(productId)"
				:productId="productId"
				@insure="handleInsure"></product-45-91-details>
			<fan6-gang-details
				v-else-if="isFgkGangZungui(productId)"
				:productId="productId"
				@insure="handleInsure"></fan6-gang-details>
			<product-223-details
				v-else-if="isFgkGangCommon(productId)"
				:productId="productId"
				@insure="handleInsure"></product-223-details>

			<product-6-door-details
				v-else-if="isFgkDoor(productId)"
				:productId="productId"
				@insure="handleInsure"></product-6-door-details>
			<product6guangfu-details
				v-else-if="isFgkGuangfu(productId)"
				:productId="productId"
				@insure="handleInsure"></product6guangfu-details>
		</template>

		<template v-else-if="insureType == 10">
			<product-31-details @insure="handleInsure"></product-31-details>
		</template>
		<template v-else-if="insureType == 7">
			<product-7-details :productId="productId" @insure="handleInsure"></product-7-details>
		</template>
		<template v-else-if="insureType == 8">
			<product-20-details :productId="productId" @insure="handleInsure"></product-20-details>
		</template>
		<template v-else-if="isYt29(productId)">
			<product-9-details :productId="productId" @insure="handleInsure"></product-9-details>
		</template>
		<template v-else-if="isYt30(productId)">
			<product-30-details :productId="productId" @insure="handleInsure"></product-30-details>
		</template>
		<template v-else-if="insureType == 11">
			<product-38-details :productId="productId" @insure="handleInsure"></product-38-details>
		</template>
		<template v-else-if="insureType == 12">
			<product-12-power-details
				v-if="isAnZePower(productId)"
				:productId="productId"
				@insure="handleInsure"></product-12-power-details>
			<product-12-gang-details
				v-else-if="isAnZeGang(productId)"
				:productId="productId"
				@insure="handleInsure"></product-12-gang-details>

			<product-12-details v-else :productId="productId" @insure="handleInsure"></product-12-details>
		</template>
		<template v-else-if="isMeiYaB(insureType, productId)">
			<product-13-detailsB :product-id="productId" @insure="handleInsure"></product-13-detailsB>
		</template>

		<template v-else-if="isMeiYaC(insureType, productId)">
			<product-13-details :productId="productId" @insure="handleInsure"></product-13-details>
		</template>

		<template v-else-if="insureType == 15">
			<product-15-details :productId="productId" @insure="handleInsure"></product-15-details>
		</template>
		<template v-else-if="insureType == 14">
			<product-14-details :productId="productId" @insure="handleInsure"></product-14-details>
		</template>
		<template v-else-if="insureType == 16">
			<product-16-details :productId="productId" @insure="handleInsure"></product-16-details>
		</template>
		<template v-else-if="insureType == 17">
			<product-17-details :productId="productId" @insure="handleInsure"></product-17-details>
		</template>
		<template v-else-if="insureType == 18">
			<product-18-details :productId="productId" @insure="handleInsure"></product-18-details>
		</template>
		<template v-else-if="insureType == 19">
			<product-19-details :productId="productId" @insure="handleInsure"></product-19-details>
		</template>
		<template v-else-if="insureType == 21">
			<product-21-details :productId="productId" @insure="handleInsure"></product-21-details>
		</template>
		<template v-else-if="insureType == 22">
			<product-22-details :productId="productId" @insure="handleInsure"></product-22-details>
		</template>
		<template v-else-if="insureType == 23">
			<product-23-details :productId="productId" @insure="handleInsure"></product-23-details>
		</template>
		<template v-else-if="insureType == 29">
			<renbao29 :productId="productId" @insure="handleInsure"></renbao29>
		</template>

		<!--    <profession-notice :insure-type="insureType" :productId="productId" :show="showNoticeDlg" @close="handleClose" @no="goInsure" @yes="goInfo"></profession-notice>-->
		<!--    <insure-begin-notice :insure-type="insureType" :isShow.sync="isShowInsureBegin" @onCancelBegin="onCancelBegin"></insure-begin-notice>-->

		<insure-begin-hint v-if="isShowInsureBegin" ref="showHint"></insure-begin-hint>
	</basic-container>
</template>

<script>
import ProfessionNotice from './professionNotice'

import Product6guangfuDetails from './details/6-guangfu'
import Product6Common from './details/6-common'
import Product6CommonYear from './details/6-common-year.vue'
import Product4591Details from './details/6-zungui'
import Product31Details from './details/31'
import Product20Details from './details/20'
import Product9Details from './details/9'
import Product30Details from './details/30'
import Product6DoorDetails from './details/6-door'

import Product38Details from './details/38'
import Product223Details from './details/6-gang-common'

import Product12Details from './details/12'
import Product12PowerDetails from './details/12-power.vue'
import Product12GangDetails from './details/12-gang.vue'
import Product22Details from './details/22'
import Product23Details from './details/23'

import Product13DetailsB from './details/13-b'
import Product13Details from './details/13'
import Product15Details from './details/15'
import Product14Details from './details/14'
import Product16Details from './details/16'
import Product18Details from './details/18'
import Product19Details from './details/19'
import Product7Details from './details/7'
import Product3Details from './details/3'
import Product17Details from './details/17'
import Product21Details from './details/21'
import fan6GangDetails from './details/6-gang-zungui'
import {insureConfig_6} from '@/const/crud/insurance/product'
import {
	isAnZeGang,
	isAnZePower,
	isFgkCommon,
	isFgkCommonYear,
	isFgkDoor,
	isFgkGangCommon,
	isFgkGangZungui,
	isFgkGuangfu,
	isFgkZungui,
	isMeiYaB,
	isMeiYaC,
	isRenBao,
	isYt29,
	isYt30,
} from '@/util/productUtil'
import {getPageId} from '@/util/commonUtils'
import {setStore} from '@/util/store'
import rrlog from '@meibao/traceback-record'
import InsureBeginNotice from '@/views/insurance/product/insureBeginNotice'
import InsureBeginHint from '@/views/insurance/product/insureBeginHint.vue'
import {getProductList} from '@/api/insurance/product'
import Renbao29 from '@/views/insurance/product/details/29.vue'

export default {
	components: {
		Renbao29,
		InsureBeginHint,
		InsureBeginNotice,
		'profession-notice': ProfessionNotice,
		'product-223-details': Product223Details,
		'product-6-common': Product6Common,
		'product-6-common-year': Product6CommonYear,
		'product-45-91-details': Product4591Details,
		'product-31-details': Product31Details,
		'product-20-details': Product20Details,
		'product-9-details': Product9Details,
		'product-30-details': Product30Details,
		'product-38-details': Product38Details,
		'product-12-details': Product12Details,
		'product-12-gang-details': Product12GangDetails,
		'product-12-power-details': Product12PowerDetails,
		'product-13-detailsB': Product13DetailsB,
		'product-13-details': Product13Details,
		'product-15-details': Product15Details,
		'product-14-details': Product14Details,
		'product-16-details': Product16Details,
		'product-18-details': Product18Details,
		'product-19-details': Product19Details,
		'product-7-details': Product7Details,
		'product-17-details': Product17Details,
		'product-6-door-details': Product6DoorDetails,
		'product-21-details': Product21Details,
		'product-22-details': Product22Details,
		'product-23-details': Product23Details,
		'product-3-details': Product3Details,

		Product6guangfuDetails,
		fan6GangDetails,
	},

	data() {
		return {
			productId: '',
			insureType: '',
			showNoticeDlg: false,
			currentStep: '0',
			insureConfig6Data: insureConfig_6,
			rrlogEventId: null,
			isShowInsureBegin: false,
			allProductList: [],
		}
	},
	watch: {
		$route() {
			this.init()
		},
	},
	computed: {},
	created() {
		this.init()
		console.log('detail----created')
		this.$Bus.$on('onAgreeInsure', this.onAgreeInsure)
		// getInsureProfile(153, 97)
	},
	beforeDestroy() {
		console.log('detail----beforeDestroy')
		this.$Bus.$off('onAgreeInsure', this.onAgreeInsure)
	},
	methods: {
		isAnZePower,
		isAnZeGang,

		isMeiYaB,
		isMeiYaC,
		init() {
			this.insureType = this.$route.params.insureType
			this.productId = this.$route.query.productId
			//获取产品
			getProductList()
				.then((response) => {
					let {code = -1, data} = response.data
					if (code === 0) {
						this.allProductList = data || []
					}
				})
				.catch(() => {})
				.finally(() => {})
		},

		handleClose() {
			this.showNoticeDlg = false
		},
		onCancelBegin() {
			this.showNoticeDlg = true
		},
		handleInsure(type = 0) {
			//人保，限制明天8点之后才能投保
			if (isRenBao(this.insureType)) {
				let endTime = new Date('2023-10-27 20:00:00').getTime()
				if (endTime >= Date.now()) {
					this.$alert('产品即将上线，请密切关注“IE保”平台。', '提示').then(() => {})
					return
				}
			}

			if (type === 0) {
				if (this.allProductList.length === 0) {
					this.$message.error('获取产品数据有误，请手动刷新浏览器重试！')
					return
				}
				//通过productId 和 insureType 查找数据
				let productData = this.allProductList.find((item) => {
					return item.id == this.productId && item.insureType == this.insureType
				})

				this.rrlogEventId = rrlog.capture(
					`去投保`,
					{
						productId: this.productId,
					},
					{
						sign: true,
					},
				)
				this.isShowInsureBegin = true
				this.$nextTick(() => {
					if (this.$refs.showHint) {
						let {informStatus = 0, informContent} = productData || {}
						informStatus = parseInt(informStatus)
						this.$refs.showHint.showHint(this.insureType, this.productId, {informStatus, informContent})
					}
				})
			} else {
				this.$router.push({
					path: this.$router.$avueRouter.getPath({
						src: `/plan/planInsure`,
					}),
					query: {
						productId: this.productId,
						insureType: this.insureType,
					},
				})
			}
		},
		onAgreeInsure() {
			this.isShowInsureBegin = false
			let pageId = getPageId()
			if (this.rrlogEventId) {
				setStore({name: `rrlog_eventid_${pageId}`, content: this.rrlogEventId, type: 'session'})
			}
			this.$router.push({
				path: this.$router.$avueRouter.getPath({
					src: `/policy/entry/${this.productId}`,
				}),
				query: {
					act: `new`,
					pageId: pageId,
					insureType: this.insureType,
				},
			})
		},
		goInfo() {
			this.showNoticeDlg = false
			setTimeout(() => {
				this.$alert('从事拒绝承保职业的雇员不属于本保险产品的保障人员范围，还请知悉', '投保提示', {
					confirmButtonText: '我知道了',
				})
			}, 500)
		},
		isFgkCommon,
		isFgkCommonYear,
		isFgkZungui,
		isFgkDoor,
		isFgkGangZungui,
		isFgkGangCommon,
		isFgkGuangfu,
		isYt29,
		isYt30,
	},
}
</script>

<style scoped>
.el-col {
	font-size: 14px;
}

.el-card {
	font-size: 14px;
	margin-bottom: 16px;
}

.item {
	margin-bottom: 18px;
}

/* .clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}

.clearfix:after {
    clear: both
} */

/* .formView >>>.el-checkbox__label {
    display: inline-grid;
    white-space: pre-line;
    word-wrap: break-word;
    overflow: hidden;
    line-height: 20px;
} */

.ul,
li {
	list-style: none;
}

span.link {
	display: block;
	text-indent: 1em;
}

h2 {
	margin: 0px;
	padding: 0px;
}
</style>
